import { Image, Link, Text } from '@weareconceptstudio/core';

//* Style
import PostItemStyle from './style';

//* Helpers
import { config } from '@/helpers';

const PostItem = ({ date, image, text, slug, title, category }) => {
	return (
		<PostItemStyle>
			<Link
				className={'wrapper-link'}
				url={`${config.routes.blog.path}${slug}`}>
				<Image
					src={image.src}
					alt={image.alt}
				/>

				<div className='wrapper-block'>
					<div className='text-wrapper'>
						<div className='wrapper-text'>
							<Text className={'h5 font-montserrat-arm-medium text-title'}>{title}</Text>

							{text ? <Text className={'p3 text-description'}>{text}</Text> : null}
						</div>
					</div>

					<div className='wrapper-data-info'>
						{/* <Text className={'p3 font-montserrat-arm-medium first-letter'}>{category.name}</Text> */}

						<Text className={'p3 font-montserrat-arm-medium first-letter'}>{date}</Text>
					</div>
				</div>
			</Link>
		</PostItemStyle>
	);
};

export default PostItem;
